export const QUERY_PARAM_KEYS = {
  action: "action",
  activityChart: "activityChart",
  activityTypes: "activityTypes",
  category: "category",
  currencyCategory: "currencyCategory",
  chains: "chains",
  sortBy: "sortBy",
  offerStatus: "offerStatus",
  collectionOfferStatus: "collectionOfferStatus",
  collectionSlugs: "collectionSlugs",
  timeframe: "timeframe",
  markets: "markets",
  currency: "currency",
  offerTypes: "offerTypes",
  offersView: "view",
  orderStatus: "orderStatus",
  price: "price",
  rarity: "rarity",
  searchQuery: "searchQuery",
  sortDirection: "sortDirection",
  status: "status",
  traits: "traits",
  floorPrice: "floorPrice",
  topOffer: "topOffer",
  numericTraits: "numericTraits",
  owner: "owner",
  direction: "direction",
  marketCap: "marketCap",
  hasNft: "hasNft",
  hasMerchandising: "hasMerchandising",
  quantityOwned: "quantityOwned",
  editableCollectionsType: "collectionType",
  editableCollectionsStatus: "collectionStatus",
  editableCollectionsContractStandard: "collectionContract",
  counterpart: "counterpart",
  isVerified: "isVerified",
  chart: "chart",
  sender: "sender",
  portfolioView: "portfolioView",
  candleSize: "candleSize",
  relayer: "relayer",
  relayers: "relayers",
  profileActivityTypes: "profileActivityTypes",
  fromChain: "fromChain",
  fromAddress: "fromAddress",
  toChain: "toChain",
  toAddress: "toAddress",
}
